/**
 * Visual values used across the Inbox preview cards that don't map to a theme
 * token. Keep them here so the previews stay visually consistent and there's a
 * single place to tweak them.
 */

/** Corner radius of the preview cards (no 20px token exists in the theme). */
export const CARD_RADIUS = '20px'

/** Elevation shared by every preview card. */
export const CARD_SHADOW = `
  0 0 1px 0 rgba(0, 0, 0, 0.15),
  0 4px 8px 0 rgba(0, 0, 0, 0.05),
  0 1px 1px 0 rgba(0, 0, 0, 0.05)
`

/** Hairline outline around the asset icon tile. */
export const HAIRLINE_SHADOW = '0 0 0 1px hsla(0, 0%, 0%, 0.07)'

/** Frosted-glass breadcrumb overlay sitting on top of the canvas image. */
export const GLASS_BLUR = '15px'

/** Size (px) of the notch bump on the top edge of the comment thread card. */
export const NOTCH_WIDTH = 30
export const NOTCH_HEIGHT = 12

/**
 * The notch as a `mask` image so it can be baked into the AnnotationCard's own
 * shape. That lets the card use `overflow: hidden` to clip its scrollable
 * thread — an `::after` tab protruding above the box would be clipped away by
 * `overflow: hidden`. A `mask` (rather than `clip-path: path()`, whose fixed
 * coordinates can't stay centred) keeps the notch centred as the card resizes.
 */
export const NOTCH_MASK_SVG =
  "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='30' height='12' viewBox='0 0 30 12'%3E%3Cpath d='M 0 12 C 6 12, 12 0, 15 0 C 18 0, 24 12, 30 12 Z' fill='%23000'/%3E%3C/svg%3E\")"

/** Square size of the asset icon / document thumbnail tiles. */
export const TILE_MEDIA_SIZE = '96px'

/**
 * Single-key shortcuts for the preview action buttons. Each key is hinted on
 * its button and registered via `useInboxActionShortcut` while the button is
 * shown. Keep them lowercase — they're matched against `event.key` and
 * uppercased for display.
 */
export const ACTION_SHORTCUTS = {
  pin: 'p',
  seeDocument: 'o',
  openInvite: 'o',
  viewFolder: 'o',
  download: 'd',
  accept: 'a',
  unfollow: 'u',
} as const
